import { useCallback, useContext } from 'react';
import transactionContext from './transactionContext';
import { TransactionLog, TransactionTypes } from './transactionTypes';
import useToastState from '../toast/useToastState';
import { OrderBookActionMapper, OrderBookType } from '../../config/constants';

const useTransactionState = (): TransactionTypes => {
    const context = useContext(transactionContext);

    const { setToast } = useToastState();

    if (!Object.keys(context).length) {
        throw new Error('TransactionContext must be used within its provider');
    }

    const { dispatch } = context;

    const addPendingTransaction = useCallback(
        (pendingTransaction: TransactionLog) => {
            dispatch({ type: 'ADD_PENDING_TRANSACTION', payload: pendingTransaction });

            setTimeout(() => {
                // if order was filled, this would have been removed from useOrderListener.
                dispatch({
                    type: 'REMOVE_PENDING_TRANSACTION',
                    payload: pendingTransaction.sigHash,
                    callback: () =>
                        setToast(
                            {
                                type: 'danger',
                                message: (
                                    <>
                                        {pendingTransaction.orderType ===
                                        OrderBookType.OPEN
                                            ? `Market Order`
                                            : `${
                                                  OrderBookActionMapper[
                                                      pendingTransaction.orderType
                                                  ]
                                              } Market`}{' '}
                                        Failed!&nbsp;
                                    </>
                                ),
                            },
                            pendingTransaction.sigHash
                        ),
                });
            }, 60000);
        },
        [dispatch, setToast]
    );

    const removePendingTransaction = useCallback(
        (sigHash: string) =>
            dispatch({
                type: 'REMOVE_PENDING_TRANSACTION',
                payload: sigHash,
            }),
        [dispatch]
    );

    return {
        ...context,
        addPendingTransaction,
        removePendingTransaction,
    };
};

export default useTransactionState;
